module.exports = "https://img.zhijierongxing.com/saas/img/banner.34a60fe1.png";